import { render, staticRenderFns } from "./visualizarHistoricoProposta.vue?vue&type=template&id=20eec39c&scoped=true"
import script from "./visualizarHistoricoProposta.vue?vue&type=script&lang=js"
export * from "./visualizarHistoricoProposta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eec39c",
  null
  
)

export default component.exports